import swal from 'sweetalert2';
export class Constants {
  public static passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?!.*[\s]).{6,12}$/;
  public static organizationRegex = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/;
  public static emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^ <>() \[\]\\.,;: \s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static firstNameRegex = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;
  public static addressRegex = /^[#.0-9a-zA-Z\s,-]+$/;

  // public static addressRegex = /^[a-zA-Z\.\,\-]+(?: [a-zA-Z0-9\.\,\-]+)*$/;
  public static subscriptionName = /^[a-zA-Z0-9!@#$%^&*-]+(?: [a-zA-Z0-9!@#$%^&*-]+)*$/;
}

export class SortList {
  public static list = [
    { category: "popularity", data: { popularity: "DESC" } }
  ];
}
export class ReportsSort {
  public static list = [
    { category: "Date: New to Old", value: { "postedDate": "DESC" } },
    { category: "Date: Old to New", value: { "postedDate": "ASC" } }
  ];
}

export class FutureResearchSort {
  public static list = [
    { category: "Date: New to Old", value: "createdAt DESC"  },
    { category: "Date: Old to New", value: "createdAt ASC" }
  ];
}

export class SortValues {
  public static list = [
    { category: "Popularity: Low to High", value: { "popularity": "ASC" } },
    { category: "Popularity: High to Low", value: { "popularity": "DESC" } },
    { category: "Date: New to Old", value: { "postedDate": "DESC" } },
    { category: "Date: Old to New", value: { "postedDate": "ASC" } },
    // { category: "Rating: High to Low", value: { "ratings": "DESC" } },
    // { category: "Rating: Low to High", value: { "ratings": "ASC" } }
  ];
}

export class SortValuesMyResearch {
  public static list = [
    { category: "Popularity: Low to High", value:  "participantCount ASC" },
    { category: "Popularity: High to Low", value: "participantCount DESC" },
    { category: "Date: New to Old", value: "createdAt DESC" },
    { category: "Date: Old to New", value:  "createdAt ASC" },
  ];
}

export const Toast = swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 5000
});
export const Toastr = swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000
});


// WEBPACK FOOTER //
// ./src/app/shared/constants/app.constants.ts